import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {TextileDataLastModified} from '@domain/textile-data/textile-data-last-modified';
import {TextileData} from '@infrastructure/http/textile-data/textile-data';
import {Observable} from 'rxjs';
import {map as rxjsMap} from 'rxjs/operators';

@Injectable()
export class HttpTextileDataService implements TextileData {
  private httpClient: HttpClient;
  private backendConfiguration: BackendConfiguration;

  public constructor(httpClient: HttpClient, backendConfiguration: BackendConfiguration) {
    this.httpClient = httpClient;
    this.backendConfiguration = backendConfiguration;
  }

  public getLastModified(): Observable<TextileDataLastModified> {
    return this.httpClient.get(`${this.backendConfiguration.getEndpoint()}textiledata/last-modified`).pipe(rxjsMap((textileDataJSON: any) => TextileDataLastModified.fromJSON(textileDataJSON)));
  }
}
